import { getCloudinaryUrl } from "@swiggy-private/js-utils";

export const ORDER_PLACEMENT_CONSTANTS = {
    TITLE: "Order Placed!",
    SUBTITLE: "The restaurant got your order, and the chefs are already on it!",
    IMAGE_ALT: "Order Placed",
    ICON_WIDTH: 124,
    ICON_HEIGHT: 162,
};

export const IMAGES = {
    ORDER_SUCCESS:
        getCloudinaryUrl(
            "portal/static-assets/images/digital-menu/all-theme-assets/order_placed.png"
        ) || "",
};

export const STYLED_CONSTANTS = {
    MARGIN_LEFT: "calc((100% - 258px)/2)", // 258px is the width of the description container
    MARGIN_RIGHT: "calc((100% - 258px)/2)",
    MARGIN_BOTTOM: "45px",
};

export const STYLED_COLORS = {
    COLOR_TOP: "#72F5C4",
};
